// Pílula padrão da carteira (moeda azul "B" + saldo de Blue Coins + "+"), criada pelo
// widget (GameWallet.createPill) — tocar abre a carteira azul direto.
import { useEffect, useRef } from 'react'
import type { GameWalletPill } from '../../commom/game-wallet'

export function WalletPill({ value, className }: { value: number; className?: string }) {
  const host = useRef<HTMLSpanElement>(null)
  const pill = useRef<GameWalletPill | null>(null)
  useEffect(() => {
    const el = host.current
    if (!el || pill.current || !window.GameWallet) return
    pill.current = window.GameWallet.createPill()
    el.appendChild(pill.current)
  }, [])
  useEffect(() => {
    pill.current?.setValue(value)
  }, [value])
  return <span ref={host} className={`gw-pill-host ${className ?? ''}`} />
}

/** Moeda azul "B" (Blue Coins) do widget, no tamanho pedido. */
export function BlueCoin({ size }: { size: number }) {
  return (
    <span
      aria-label="Blue Coins"
      style={{ width: size, height: size, lineHeight: 0, display: 'inline-block' }}
      dangerouslySetInnerHTML={{ __html: window.GameWallet?.coinSvg(size) ?? '' }}
    />
  )
}
